import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from './utils/shadcn-utils';
_jsx("h1", { className: "text-2xl font-semibold tracking-tight", children: "Kalend\u00E1\u0159 rezervac\u00ED" });
const headlineVariants = cva('font-semibold leading-tight text-foreground ', {
    variants: {
        level: {
            1: 'text-2xl font-semibold tracking-tight',
            2: 'text-xl font-semibold tracking-tight',
            3: 'text-lg lg:text-xl font-semibold',
            4: 'text-base lg:text-lg font-semibold',
            5: 'text-sm lg:text-base font-medium',
            6: 'text-xs lg:text-sm font-medium'
        },
        color: {
            default: 'text-foreground',
            muted: 'text-muted-foreground',
            primary: 'text-primary',
            secondary: 'text-secondary-foreground',
            accent: 'text-accent-foreground',
            destructive: 'text-destructive'
        },
        align: {
            left: 'text-left',
            center: 'text-center',
            right: 'text-right'
        }
    },
    defaultVariants: {
        level: 1,
        color: 'default',
        align: 'left'
    }
});
function Headline({ className, level = 1, color, align, asChild = false, ...props }) {
    const Comp = asChild ? Slot : `h${level}`;
    return _jsx(Comp, { className: cn(headlineVariants({ level, color, align, className })), ...props });
}
export { Headline };
//# sourceMappingURL=headline.js.map